/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from "../Common/Buttons/Button";

interface WizardStepErrorProps {
  errorMessage?: any;
  handlePrevious: (e?: any) => void;
  step: number;
  hideStepCounter?: boolean;
}

export const WizardStepError = ({
  errorMessage,
  handlePrevious,
  step,
  hideStepCounter = false,
}: WizardStepErrorProps) => (
  <>
    <div className="shadow-introBox bg-white w-full h-full rounded-[16px]">
      <div className="space-y-4 px-[16px] py-[32px] md:p-[32px]">
        <div className="flex flex-col justify-center items-center mt-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="88"
            viewBox="0 0 89 88"
            fill="none"
          >
            <circle
              cx="44.5"
              cy="44"
              r="43"
              fill="#FF8E6A"
              stroke="#B83810"
              strokeWidth="2"
            />
            <path
              d="M44.5001 86C67.6961 86 86.5001 67.196 86.5001 44C86.5001 38.5056 79.9926 39.2296 78.1424 44.4031C65.7023 79.1877 24.3165 82.0967 5.07031 58.5C10.9748 74.551 26.4004 86 44.5001 86Z"
              fill="#FF3D00"
            />
            <path
              d="M44.5002 34.949L33.7522 24.201C31.2528 21.7017 27.2005 21.7017 24.7012 24.201C22.2018 26.7004 22.2018 30.7526 24.7012 33.252L35.4492 44L24.7012 54.748C22.2018 57.2474 22.2018 61.2996 24.7012 63.799C27.2005 66.2983 31.2528 66.2983 33.7522 63.799L44.5002 53.051L55.2482 63.799C57.7476 66.2983 61.7998 66.2983 64.2992 63.799C66.7985 61.2996 66.7985 57.2474 64.2992 54.748L53.5511 44L64.2992 33.252C66.7985 30.7526 66.7985 26.7004 64.2992 24.201C61.7998 21.7017 57.7476 21.7017 55.2482 24.201L44.5002 34.949Z"
              fill="#FFE5DD"
              stroke="#B83810"
              strokeWidth="2"
            />
          </svg>
          <h3 className="py-[16px] text-[32px] font-semibold leading-[127%]">
            Error
          </h3>
          <p>{errorMessage ? errorMessage : "Unable to fetch beneficiaries"}</p>
        </div>
      </div>
    </div>

    <div className="flex items-center space-x-4 lg:space-x-0 justify-between mt-[24px] md:shadow-md bg-white rounded-[16px] px-0 py-[32px] md:p-[32px]">
      <div className="w-[218px]">
        <Button
          ariaLabel="previous"
          variant="secondary"
          label="Previous"
          iconAlignment="left"
          //loading={isSubmitting}
          handleClick={handlePrevious}
        />
      </div>
      {!hideStepCounter && (
        <div className="hidden lg:block  flex-1 text-center">
          <p className="leading-[127%] font-normal text-[14px] text-[#C6C6C6]">
            {step} out of 4
          </p>
        </div>
      )}
      <div className="w-[218px]">
        <Button
          iconVisibility="show"
          ariaLabel="next"
          label="Next"
          //loading={isSubmitting}
          isDisabled={true}
          handleClick={() => {}}
        />
      </div>
    </div>
  </>
);
